










































































































































































































import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import { Wallet } from '@wallet/interfaces/wallet';

library.add(faSync);

@Component({
  name: 'bpc-wallet-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    ValidationObserver,
    'bpc-drawer-modal': DrawerModal,
  },
})
export default class WalletTable extends mixins(AbstractTable) {
  $refs: AbstractTable['$refs'] & {
    stdForm: InstanceType<typeof StdForm> & {
      fetchEntityAndConfig(): void;
    };
  };
  @Prop({ type: Array, default: null }) declare readonly selectConfigName: string[];
  @Prop({ type: String, default: 'default' }) readonly editFormConfigName: string;
  @Prop(String) declare readonly title: string;
  @Prop(String) declare readonly subtitle: string;

  public displayConfigName: string = 'table';
  public entity: Wallet = null;
  public entityName = 'wallet';
  public pluralEntityName = 'wallets';
  public showDrawerSettingSection: boolean = false;
  public showSettingForm: boolean = false;
  public permissionsEntityName = 'wallets';
  public showSaveButton: boolean = false;

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  get rowActions() {
    return {
      ...this.defaultRowActions,
      ...this.customRowActions,
    };
  }

  getModalTitle(): string {
    return this.$t('global.models.' + this.entityName + '.name').toString();
  }

  onShow(e) {
    this.onEdit(e);
  }

  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}

  extendUpdateRowActions(entity: any) {
    entity.actions.show.show = true;
    entity.actions.show.activated = true;
  }
}
